'use client';

import { useEffect, useState } from 'react';

export const useIsDevice = (devices: string[]): boolean => {
  const [isDevice, setIsDevice] = useState(false);

  useEffect(() => {
    if (typeof navigator !== 'undefined') {
      const userAgent = navigator.userAgent;
      // Check if any of the specified devices match the user agent
      const deviceRegex = new RegExp(devices.join('|'), 'i');
      setIsDevice(deviceRegex.test(userAgent));
    }
  }, [devices]); // Add devices as a dependency

  return isDevice;
};
